import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['index', 'clientPricingUnit', 'workDays', 'amount']);
  const createProjectClient = `createProjectClient(input: ${dataModify})`;
  return gql`
  mutation {
    ${createProjectClient} {
      id
    }
  }
`;
};
